__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.25-0a96-amber-user-website-prod-hk-1890/assets/";